export const arrow = ['0 0 32 32', `
  <path d="M15.986 22.553c-0.464-0.002-0.887-0.176-1.209-0.461l0.002 0.002-14.302-10.524c-0.29-0.215-0.476-0.557-0.476-0.942 0-0.646 0.523-1.169 1.169-1.169 0.261 0 0.501 0.085 0.696 0.229l-0.003-0.002 14.125 10.403 14.153-10.414c0.191-0.142 0.432-0.227 0.692-0.227 0.646 0 1.169 0.523 1.169 1.169 0 0.385-0.186 0.726-0.473 0.939l-0.003 0.002-14.33 10.536c-0.32 0.285-0.743 0.459-1.207 0.46h-0z"></path>
`]

